// src/utils/createEmptyRecordFromFormType.ts
import {
  RESOURCE_CURATION_CONFIG,
  normalizeFormType,
} from '@constants/RESOURCE_CURATION_CONFIG';

import type { FormType } from '@utils/fhir-mappers';

/**
 * Deep clone helper so various forms don't accidentally share
 * object/array references.
 */
function deepClone<T>(value: T): T {
  return value === null || value === undefined
    ? value
    : JSON.parse(JSON.stringify(value));
}

/**
 * Creates the initial (empty) record for a given formType.
 *
 * For OCR-enabled resources, we pull the defaults from RESOURCE_CURATION_CONFIG.
 * For everything else (Genetic Information, Insurance, Body, etc.), we fall
 * back to a simple Observation-like shell — same as before.
 */
export const createEmptyRecordFromFormType = (formType: FormType): any => {
  const normalized = normalizeFormType(formType as unknown as string);
  if (normalized in RESOURCE_CURATION_CONFIG) {
    const cfg = RESOURCE_CURATION_CONFIG[normalized];
    return deepClone(cfg.defaults);
  }

  // Fallback — safe Observation-like shell (used by UI-only forms)
  return {
    resourceType: 'Observation',
    code: { text: '' },
  };
};
